import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS } from "../../../config/api";
import * as bootstrap from "bootstrap";
import Pagination from "../../../components/private/pagination";

const CostCenter = () => {
  const { token, authFetch } = useContext(AuthContext);

  const [costCenters, setCostCenters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [programs, setPrograms] = useState([]);
  const [areas, setAreas] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedCostCenter, setSelectedCostCenter] = useState(null);

  // FILTROS
  const [search, setSearch] = useState("");
  const [stateFilter, setStateFilter] = useState("all");
  const [areaFilter, setAreaFilter] = useState("all");

  // PAGINACIÓN
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  // MODAL
  let modalInstance = null;

  const [formData, setFormData] = useState({
    area: "",
    name_cost_center: "",
    cost_center: "",
    program: "",
    type_cost_center: ""
  });

  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");
  // =====================================================
  // CARGAR COST CENTER
  // =====================================================

  useEffect(() => {
    if (!token) return;

    const loadCostCenters = async () => {
      setLoading(true);

      try {
        const data = await authFetch(ENDPOINTS.getCostcenter);

        if (data.success && data.cost_center) {
          setCostCenters(data.cost_center);
        } else {
          setCostCenters([]);
        }

      } catch (error) {
        console.error("Error cargando centros de costo:", error);
        setCostCenters([]);
      }

      setLoading(false);
    };

    loadCostCenters();
  }, [token, authFetch]);

    // =====================================================
    // CARGAR AREAS
    // =====================================================

  useEffect(() => {
  if (!token) return;

  const loadAreas = async () => {
    try {
      const data = await authFetch(ENDPOINTS.getarea);

      if (data.success && data.data) {
        setAreas(data.data);
      } else {
        setAreas([]);
      }

    } catch (error) {
      console.error("No se puedo traer las áreas:", error);
      setAreas([]);
    }
  };

  loadAreas();
}, [token, authFetch]);

    // =====================================================
    // CARGAR PROGRAM
    // =====================================================

    useEffect(() => {
    if (!token) return;

    const loadPrograms = async () => {
        try {
        const data = await authFetch(ENDPOINTS.get_programas);

        if (data.success && data.data) {
            setPrograms(data.data);
        } else {
            setPrograms([]);
        }

        } catch (error) {
        console.error("No se pudo traer los programas:", error);
        setPrograms([]);
        }
    };

    loadPrograms();
    }, [token, authFetch]);


    const filteredPrograms = programs.filter(
    (prog) => Number(prog.area) === Number(formData.area)
  );

  // =====================================================
  // FILTROS
  // =====================================================

  const filtered = (costCenters || []).filter((cc) => {
    const query = search.toLowerCase();

    const matchesSearch =
      String(cc.cost_center).includes(query) ||
      cc.program_name?.toLowerCase().includes(query);

    const matchesState =
      stateFilter === "all" || String(cc.state) === stateFilter;

    const matchesArea =
      areaFilter === "all" || String(cc.area) === areaFilter;

    return matchesSearch && matchesState && matchesArea;
  });

  // =====================================================
  // PAGINACIÓN
  // =====================================================

  const totalPages = Math.ceil(filtered.length / recordsPerPage);

  const currentData = filtered.slice(
    (currentPage - 1) * recordsPerPage,
    currentPage * recordsPerPage
  );

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // =====================================================
  // MODAL CREAR
  // =====================================================

  const openModal = () => {
    const modalEl = document.getElementById("createCostCenterModal");
    modalInstance = new bootstrap.Modal(modalEl);
    modalInstance.show();
  };

  const closeModal = () => {
  const modalEl = document.getElementById("createCostCenterModal");
  const instance = bootstrap.Modal.getInstance(modalEl);

  if (instance) {
    instance.hide();
  }

  //
  if (document.activeElement) {
    document.activeElement.blur();
  }

  setFormData({
    area: "",
    name_cost_center: "",
    cost_center: "",
    program: "",
    type_cost_center:""
  });

  setFormError("");
  setFormSuccess("");
};
  // =====================================================
  // MODAL CAMBIAR ESTADO
  // =====================================================

    const openStateModal = (cc) => {
    setSelectedCostCenter(cc);
    setShowModal(true);
    };

    const closeStateModal = () => {
    setSelectedCostCenter(null);
    setShowModal(false);
    };
  // =====================================================
  // CREAR COST CENTER
  // =====================================================

  const handleCreate = async () => {

    setFormError("");
    setFormSuccess("");

    if (
      !formData.area ||
      !formData.name_cost_center ||
      !formData.cost_center ||
      !formData.type_cost_center
    ) {
      setFormError("Todos los campos obligatorios deben completarse");
      return;
    }

    try {
      const response = await authFetch(ENDPOINTS.createCostcenter, {
        method: "POST",
        body: JSON.stringify(formData)
      });

      if (response.success) {

        setFormSuccess("Centro de costo creado correctamente");

        const reload = await authFetch(ENDPOINTS.getCostcenter);

        if (reload.success) {
          setCostCenters(reload.cost_center);
        }

        setTimeout(() => {
          closeModal();
        }, 1500);

      } else {
        setFormError(response.message || "Error al crear");
      }

    } catch (error) {
      console.error(error);
      setFormError("Error al crear centro de costo");
    }
  };

  // =====================================================
  // CAMBIAR ESTADO
  // =====================================================

    const handleConfirmToggle = async () => {

    if (!selectedCostCenter) return;

    try {

        const newState = Number(selectedCostCenter.state) === 1 ? 0 : 1;

        const res = await authFetch(
        `${ENDPOINTS.changeStateCostCenter}?id=${selectedCostCenter.id}`,
        {
            method: "PUT",
            body: JSON.stringify({ state: newState })
        }
        );

        if (res.success) {

        // 🔥 UPDATE LOCAL (sin recargar)
        setCostCenters(prev =>
            prev.map(cc =>
            cc.id === selectedCostCenter.id
                ? { ...cc, state: newState }
                : cc
            )
        );

        alert("Estado actualizado correctamente");

        } else {
        alert(res.message);
        }

    } catch (error) {
        console.error(error);
        alert("Error con el servidor");
    }

    closeStateModal();
    };

  // =====================================================
  // RENDER
  // =====================================================

  if (loading) return <p>Cargando centros de costo...</p>;

  return (
    <div className="container mt-4 p-4">

      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Centros de Costo</h2>

        <button className="btn btn-outline-pink" onClick={openModal}>
          <i className="bi bi-plus-circle"></i> Crear Centro de Costo
        </button>
      </div>

      {/* FILTROS */}
      <div className="row mb-3">

        <div className="col-md-5">
          <label className="m-1">Buscar por centro de costo o programa</label>
          <input
            type="text"
            className="form-control"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>

        <div className="col-md-3">
          <label className="m-1">Estado</label>
          <select
            className="form-select"
            value={stateFilter}
            onChange={(e) => setStateFilter(e.target.value)}
          >
            <option value="all">Todos</option>
            <option value="1">Activos</option>
            <option value="0">Inactivos</option>
          </select>
        </div>

        <div className="col-md-3">
          <label className="m-1">Área</label>
          <select
            className="form-select"
            value={areaFilter}
            onChange={(e) => {
              setAreaFilter(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="all">Todas las areas</option>

            {areas.map((area) => (
              <option key={area.id_area} value={area.id_area}>
                {area.name}
              </option>
            ))}
          </select>
        </div>

      </div>

      {/* TABLA */}
      {currentData.length > 0 ? (
        <>
          <table className="table table-hover">

            <thead className="table-secondary">
              <tr>
                <th>Centro de Costo</th>
                <th>Area</th>
                <th>Programa</th>
                <th>Nombre</th>
                <th>Tipo</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>

            <tbody>
              {currentData.map((cc) => (
                <tr key={cc.id}>

                  <td>{cc.cost_center}</td>

                  <td>{cc.area_name}</td>
                  <td>{cc.program_name || "Sin programa"}</td>
                  <td>{cc.name_cost_center}</td>
                  <td>{cc.type_cost_center}</td>

                  <td>
                    {Number(cc.state) === 1 ? "Activo" : "Inactivo"}
                  </td>

                  <td>
                        <button
                            className={`btn btn-sm ${
                            Number(cc.state) === 1
                                ? "btn-outline-pink"
                                : "btn-outline-purple"
                            }`}
                            onClick={() => openStateModal(cc)}
                        >
                            <i className="bi bi-power me-1"></i>
                            {Number(cc.state) === 1 ? "Desactivar" : "Activar"}
                        </button>
                    </td>

                </tr>
              ))}
            </tbody>

          </table>

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
          />
        </>
      ) : (
        <p>No hay centros de costo registrados.</p>
      )}

      {/* MODAL CREAR */}
      <div
        className="modal fade"
        id="createCostCenterModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">

          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Crear Centro de Costo</h5>
              <button className="btn-close" onClick={closeModal}></button>
            </div>

            <div className="modal-body">

              {formError && (
                <div className="alert alert-danger py-2">
                  {formError}
                </div>
              )}

              {formSuccess && (
                <div className="alert alert-success py-2">
                  {formSuccess}
                </div>
              )}

              <div className="mb-3">
                <label>Área</label>
                <select
                  className="form-select"
                  value={formData.area}
                  onChange={(e) => {
                    const newArea = Number(e.target.value);

                    setFormData(prev => ({
                      ...prev,
                      area: newArea,
                      program: "" 
                    }));
                  }}
                >
                  <option value=""hidden>Seleccione un área</option>

                  {areas.map((area) => (
                    <option key={area.id_area} value={area.id_area}>
                      {area.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label>Programa</label>
                <select
                    className="form-select"
                    value={formData.program}
                    disabled={!formData.area}
                    onChange={(e) =>
                        setFormData(prev => ({
                        ...prev,
                        program: e.target.value
                        }))
                    }
                    >
                    <option value=""hidden>Sin programa</option>

                    {filteredPrograms.map((prog) => (
                        <option key={prog.id} value={prog.id}>
                        {prog.program_name}
                        </option>
                    ))}
                    </select>
              </div>

              <div className="mb-3">
                <label>Nombre del centro de costo</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.name_cost_center}
                  onChange={(e) =>
                    setFormData(prev => ({
                      ...prev,
                      name_cost_center: e.target.value
                    }))
                  }
                />
              </div>

              
              <div className="mb-3">
                <label>Número de Centro de Costo</label>
                <input
                  type="number"
                  className="form-control"
                  value={formData.cost_center}
                  onChange={(e) =>
                    setFormData(prev => ({
                      ...prev,
                      cost_center: e.target.value
                    }))
                  }
                />
              </div>

              <div className="mb-3">
                <label>Tipo de centro de costo</label>
                <select
                  className="form-select"
                  value={formData.type_cost_center}
                  onChange={(e) =>
                    setFormData(prev => ({
                      ...prev,
                      type_cost_center: e.target.value
                    }))
                  }
                >
                  <option value="" hidden>Seleccione</option>
                  <option value="Operativo">Operativo</option>
                  <option value="Administrativo">Administrativo</option>
                  <option value="Reembolsable">Reembolsable</option>
                </select>
              </div>

            </div>

            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={closeModal}>
                Cancelar
              </button>

              <button
                className="btn btn-outline-pink"
                onClick={handleCreate}
              >
                Crear
              </button>
            </div>

          </div>

        </div>
      </div>

      {/* MODAL DE CAMBIAR ESTADO */}
      {showModal && (
        <>
            <div
            className="modal-backdrop fade show"
            onClick={closeStateModal}
            ></div>

            <div className="modal fade show d-block">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">

                <div className="modal-header">
                    <h5 className="modal-title">Cambiar Estado</h5>
                    <button className="btn-close" onClick={closeStateModal}></button>
                </div>

                <div className="modal-body">
                    <p>
                    ¿Deseas cambiar el estado del centro de costo{" "}
                    <b>{selectedCostCenter?.cost_center}</b>?
                    </p>
                </div>

                <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={closeStateModal}>
                    Cancelar
                    </button>

                    <button
                    className="btn btn-outline-pink"
                    onClick={handleConfirmToggle}
                    >
                    Confirmar
                    </button>
                </div>

                </div>
            </div>
            </div>
        </>
        )}

    </div>
  );
};

export default CostCenter;